import React, { useState } from "react";
import Axios from "../../axios/axios";
import { toast } from "react-toastify";
import { Header } from "../../components/SpearParts/Layouts/Header";
import { useNavigate } from "react-router-dom";
import AlertModal from "../../actions/AlertModal";
import { FaEye, FaEyeSlash } from "react-icons/fa";

// function ForgotPswd() {
//   const [email, setEmail] = useState("");
//   const [otpSent, setOtpSent] = useState(false);
//   const [otp, setOtp] = useState("");
//   const [newPassword, setNewPassword] = useState("");
//   const navigate = useNavigate();
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [modalMessage, setModalMessage] = useState("");
//   const [confirmPassword, setConfirmPassword] = useState("");

//   const handleModalClose = () => {
//     setIsModalOpen(false);
//     navigate("/login");
//   };

//   const handleSendOtp = async () => {
//     try {
//       const response = await Axios.post("/sendotp", { email });
//       toast.success(response.data.message);
//       setOtpSent(true);
//     } catch (error) {
//       toast.error(error.response?.data?.message || "Failed to send OTP");
//     }
//   };

//   const handleResetPassword = async () => {
//   if (newPassword !== confirmPassword) {
//     toast.error("Passwords do not match");
//     return;
//   }

//   try {
//     const response = await Axios.post("/resetpass", {
//       email,
//       otp,
//       newPassword,
//     });

//     setModalMessage("Password reset successful.");
//     setIsModalOpen(true);
//   } catch (error) {
//     toast.error(error.response?.data?.message || "Failed to reset password");
//   }
// };

//   return (
//     <div>
//       <section id="login">
//         <div className="container">
//           <div className="col-md-6 offset-md-3">
//             {/* <h3>Login</h3>
//                <p>From its medieval origins to the digital era, learn everything there is to know
//                  about the ubiquitous lorem ipsum passage.</p> */}

//             <div>
//               <section id="login">
//                 <div className="container">
//                   <div className="col-md-6 offset-md-3">
//                     <div
//                       className="container mt-5"
//                       style={{ maxWidth: "500px" }}
//                     >
//                       <h3>Forgot Password</h3>
//                       <div className="form-group mb-3">
//                         <label>Email</label>
//                         <input
//                           type="email"
//                           className="form-control"
//                           value={email}
//                           onChange={(e) => setEmail(e.target.value)}
//                           disabled={otpSent}
//                         />
//                       </div>

//                       {!otpSent ? (
//                         <button
//                           className="btn btn-primary"
//                           onClick={handleSendOtp}
//                         >
//                           Send OTP
//                         </button>
//                       ) : (
//                         <>
//                           <div className="form-group mb-3 mt-3">
//                             <label>Enter OTP</label>
//                             <input
//                               type="text"
//                               className="form-control"
//                               value={otp}
//                               onChange={(e) => setOtp(e.target.value)}
//                             />
//                           </div>
//                           <div className="form-group mb-3">
//                             <label>New Password</label>
//                             <input
//                               type="password"
//                               className="form-control"
//                               value={newPassword}
//                               onChange={(e) => setNewPassword(e.target.value)}
//                             />
//                           </div>
//                           <div className="form-group mb-3">
//                             <label>Confirm Password</label>
//                             <input
//                               type="password"
//                               className="form-control"
//                               value={confirmPassword}
//                               onChange={(e) =>
//                                 setConfirmPassword(e.target.value)
//                               }
//                             />
//                           </div>

//                           <button
//                             className="btn btn-success"
//                             onClick={handleResetPassword}
//                           >
//                             Reset Password
//                           </button>
//                         </>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               </section>
//             </div>
//           </div>
//         </div>
//       </section>
//       <AlertModal
//         isOpen={isModalOpen}
//         message={modalMessage}
//         onClose={handleModalClose}
//       />
//     </div>
//   );
// }

function ForgotPswd() {
  const [email, setEmail] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [userType, setUserType] = useState("customer"); // Default to customer
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleModalClose = () => {
    setIsModalOpen(false);
    navigate("/login");
  };

  const handleSendOtp = async () => {
    if (!email) {
      toast.error("Please enter your email");
      return;
    }

    try {
      const response = await Axios.post("/sendotp", {
        email,
        userType,
      });
      toast.success(response.data.message);
      setOtpSent(true);
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to send OTP");
    }
  };

  const handleResetPassword = async () => {
    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    try {
      const response = await Axios.post("/resetpass", {
        email,
        otp,
        newPassword,
        userType,
      });

      setModalMessage("Password reset successful.");
      setIsModalOpen(true);
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to reset password");
    }
  };

  return (
    <div>
      <Header /> {/* Make sure to include your Header component */}
      <section id="login">
        <div className="container">
          <div className="col-md-6 offset-md-3">
            <div>
              <section id="login">
                <div className="container">
                  <div className="col-md-6 offset-md-3">
                    <div
                      className="container mt-5"
                      style={{ maxWidth: "500px" }}
                    >
                      <h3>Forgot Password</h3>

                      {/* User Type Selection */}
                      <div className="form-group mb-3">
                        <label>Account Type</label>
                        <div className="d-flex">
                          <div className="form-check me-3">
                            <input
                              className="form-check-input"
                              type="radio"
                              id="customer"
                              value="customer"
                              checked={userType === "customer"}
                              onChange={() => setUserType("customer")}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="customer"
                            >
                              Customer
                            </label>
                          </div>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              id="supplier"
                              value="supplier"
                              checked={userType === "supplier"}
                              onChange={() => setUserType("supplier")}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="supplier"
                            >
                              Supplier
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="form-group mb-3">
                        <label>Email</label>
                        <input
                          type="email"
                          className="form-control"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          disabled={otpSent}
                        />
                      </div>

                      {!otpSent ? (
                        <button
                          className="btn btn-primary"
                          onClick={handleSendOtp}
                        >
                          Send OTP
                        </button>
                      ) : (
                        <>
                          <div className="form-group mb-3 mt-3">
                            <label>Enter OTP</label>
                            <input
                              type="text"
                              className="form-control"
                              value={otp}
                              onChange={(e) => setOtp(e.target.value)}
                            />
                          </div>
                          <div className="form-group mb-3">
                            <label>New Password</label>
                            <input
                              type="password"
                              className="form-control"
                              value={newPassword}
                              onChange={(e) => setNewPassword(e.target.value)}
                            />
                          </div>
                          <div className="form-group mb-3">
                            <label>Confirm Password</label>
                            <div className="input-group">
                              <input
                                type={showConfirmPassword ? "text" : "password"}
                                className="form-control"
                                value={confirmPassword}
                                onChange={(e) =>
                                  setConfirmPassword(e.target.value)
                                }
                              />
                              <span
                                className="input-group-text"
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  setShowConfirmPassword(!showConfirmPassword)
                                }
                              >
                                {showConfirmPassword ? (
                                  <FaEye />
                                ) : (
                                  <FaEyeSlash />
                                )}
                              </span>
                            </div>
                          </div>

                          <button
                            className="btn btn-success"
                            onClick={handleResetPassword}
                          >
                            Reset Password
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>
      <AlertModal
        isOpen={isModalOpen}
        message={modalMessage}
        onClose={handleModalClose}
      />
    </div>
  );
}

export default ForgotPswd;
